// extracted by mini-css-extract-plugin
module.exports = {"divider":"divider_divider__2cLtL","divider_inner_text":"divider_divider_inner_text__U6IZR"};